import React, { Component } from 'react';

import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import { GetActivitiesTags } from '../../actions/activityAction'

import { Button, Checkbox, Chip, Grid, IconButton, Popover, Slide, TextField } from '@material-ui/core';
import { renderActivityDatePicker, renderSwitchV3 } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment';


const options=['7 Days', '2 Weeks', '30 Days'];

const registrationsOptions = ['Greater than', 'Less than', 'Between']

class ActivityFilters extends Component {
    constructor(props){
        super(props);
        this.state={
            dateChanged:(this.props.filters && this.props.filters.dateChanged)? this.props.filters.dateChanged : false,
            dateOptionSelected:(this.props.filters && this.props.filters.dateOptionSelected)? this.props.filters.dateOptionSelected : null,
            optionInFuture:(this.props.filters)? this.props.filters.optionInFuture:undefined,
            startDate: (this.props.filters && this.props.filters.startDate)? this.props.filters.startDate : new Date(),
            endDate:  (this.props.filters && this.props.filters.endDate)? this.props.filters.endDate : new Date(),
            categoriesSelected:(this.props.filters && this.props.filters.categoriesSelected)? this.props.filters.categoriesSelected : [],
            registrationsActive:(this.props.filters && this.props.filters.registrationsActive)? this.props.filters.registrationsActive : false,
            registrationsOption:(this.props.filters && this.props.filters.registrationsOption)? this.props.filters.registrationsOption : registrationsOptions[0],
            lowerLimit:(this.props.filters && this.props.filters.lowerLimit)? this.props.filters.lowerLimit : 1,
            upperLimit: (this.props.filters && this.props.filters.upperLimit)? this.props.filters.upperLimit : 10,
            unlimitedSeats: (this.props.filters && this.props.filters.unlimitedSeats)? this.props.filters.unlimitedSeats :  false,
            tagsSelected:(this.props.filters && this.props.filters.tagsSelected)? this.props.filters.tagsSelected : []
           
        }    

    };

    componentDidMount(){
        this.getTags();
    }

    getTags = async ()=>{
        const id = localStorage.getItem('communityId')

        const newTags = await this.props.GetActivitiesTags(id, this.state.dateChanged ,this.state.dateOptionSelected, this.state.startDate, this.state.endDate)

        const existTags = this.state.tagsSelected;

        if(existTags.length>0){ //If we had tags already selected is possible that those tags aren't include in the new date range selected
            //remove the tags that aren't in our current tags arr 
            const arrFiltered = existTags.filter(t=>newTags.find(i=>i===t))

            this.setState({tagsSelected:arrFiltered})

        }

    }


    setActivityDate(date, type) {

        const upd={
            startDate:this.state.startDate,
            endDate:this.state.endDate,
            dateChanged:true,
            dateOptionSelected:null
        }

        if(type==='start'){

            if(date>this.state.endDate){
                const add1Day=moment(date).add(1,'day')

                upd.startDate = date;
                upd.endDate = add1Day

            }else{
                upd.startDate = date;
            }
           

        }else if(type==='end'){
        
            if(date<this.state.startDate){
                const remove1Day=moment(date).subtract(1,'day')

                upd.endDate = date;
                upd.startDate = remove1Day                

            }else{
                upd.endDate = date;
            }
        }

        this.setState(upd, ()=>this.getTags())

    }

    handleSelectOption=(e,op, future)=>{
        this.setState({
            dateOptionSelected:op,
            optionInFuture:future,
            dateChanged:false,
            startDate: new Date(),
            endDate: new Date()
        }, ()=>this.getTags())
    }
    handleSelectCategory = (category) =>{

        const arr = this.state.categoriesSelected;

        const item = arr.find(item =>item===category);

        if (!item) {
            arr.push(category)
        }
        else {
            const indexToDelete = arr.indexOf(category);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ categoriesSelected: arr });

    }

    handleSelectTag=(tag)=>{
        const arr = this.state.tagsSelected;

        const item = arr.find(item =>item===tag);

        if (!item) {
            arr.push(tag)
        }
        else {
            const indexToDelete = arr.indexOf(tag);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ tagsSelected: arr });
    }

    resetfilter=()=>{
        this.setState({
            dateChanged:false,
            dateOptionSelected:null,
            optionInFuture:undefined,
            startDate: new Date(),
            endDate: new Date(),
            categoriesSelected:[],
            registrationsActive:false,
            registrationsOption:registrationsOptions[0],
            lowerLimit:1,
            upperLimit:10,
            unlimitedSeats:false,
            tagsSelected:[]
        }, ()=>this.getTags());

        this.props.resetFilters();
    }

    handleApplyFilters = ()=>{

        const filtersToSend = {...this.state}
        this.props.applyFilters(filtersToSend)
        this.props.onClose();
    }

    
    CheckForValidCaracters = (input) => {
        let pattern = '[0-9]';

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    render() {
        return (
            <>
                <Popover
                    id="ActivityFilterPopOver"
                    open={true}
                    onClose={this.props.onClose}
                    anchorEl={this.props.anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                        
                    PaperProps={{
                        className:'activity_filters_popover',
                    }}
                    elevation={0}
                >
                    <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                        <Grid container xs={12} className='activity_filters_slide'>
                            <form style={{width:'100%'}}>

                                {/* Title and close icon */}
                                <Grid item container xs={12} justifyContent='space-between' alignItems='center'>
                                    <Grid item className='filters_title'>Filters</Grid>

                                    <IconButton onClick={()=>this.props.onClose()}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/times-circle.svg'
                                            alt='close_icon'
                                            width='32px'
                                            height='32px'
                                            style={{fontWeight:'bold'}}
                                        />
                                    </IconButton>
                                </Grid>

                                {/* Apply filters buttons */}
                                <Grid item container xs={12}>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                    <Button className='filters_clear_btn' onClick={this.resetfilter}>Clear All</Button>
                                </Grid>

                                {/* Date ranges */}
                                <Grid item container xs={12} justifyContent='space-between'>
                                    <Grid item xs={12} className='filters_subtitles sectionMargin'>Date Range</Grid>

                                    {/* Date range */}
                                    <Grid item className={!this.state.dateChanged? 'date_range_box' :'date_range_box_selected'}>
                                        <Field
                                            name="startDate"
                                            labelDate="From"
                                            selectedDate={this.state.startDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.setActivityDate(date, 'start')}
                                            maxLength={20}
                                            component={renderActivityDatePicker}
                                            idToSet='filters_date'
                                            id='activity_filters_date'
                                            active={!this.state.dateOptionSelected}
                                        />
                                    </Grid>

                                    <Grid item className={!this.state.dateChanged? 'date_range_box' :'date_range_box_selected'}>
                                        <Field
                                            name="endDate"
                                            labelDate="To"
                                            selectedDate={this.state.endDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.setActivityDate(date, 'end')}
                                            maxLength={20}
                                            component={renderActivityDatePicker}
                                            idToSet='filters_end_date'
                                            id='activity_filters_end_date'
                                            active={!this.state.dateOptionSelected}

                                        />
                                    </Grid>


                                    {/* Dates Fixed Options */}
                                    <Grid item xs={12} className='ligth_txt sectionMargin'>Or the next</Grid>

                                    {
                                        options.map((op, index)=>{
                                            return(
                                                <Grid item key={`option_${index}`} 
                                                    onClick={(e)=>this.handleSelectOption(e,op, true)}
                                                    className={(this.state.dateOptionSelected===op && this.state.optionInFuture===true)? 'ligth_txt option_box_selected' : 'ligth_txt option_box' }
                                                    style={{
                                                        color:(this.state.dateOptionSelected)?'#009EDD':'#757575', 
                                                        border:(this.state.dateOptionSelected)?'2px solid #009EDD':'2px solid #868686'
                                                    }} 
                                                >
                                                    {op}
                                                </Grid>
                                            )
                                        })
                                    }

                                    
                                    {/* Past Dates Fixed Options */}
                                    <Grid item xs={12} className='ligth_txt sectionMargin'>Or the past</Grid>
                                    {
                                        options.map((op, index)=>{
                                            return(
                                                <Grid item key={`option_${index}`} 
                                                    onClick={(e)=>this.handleSelectOption(e,op,false)}
                                                    className={(this.state.dateOptionSelected===op && this.state.optionInFuture===false)? 'ligth_txt option_box_selected' : 'ligth_txt option_box' }
                                                    style={{
                                                        color:(this.state.dateOptionSelected)?'#009EDD':'#757575', 
                                                        border:(this.state.dateOptionSelected)?'2px solid #009EDD':'2px solid #868686'
                                                    }} 
                                                >
                                                    {op}
                                                </Grid>
                                            )
                                        })
                                    }


                                </Grid>


                                {/* Categories filters */}
                                <Grid item container xs={12} justifyContent='flex-start' className='sectionMargin'>
                                    <Grid item xs={12} className='filters_subtitles'>Categories</Grid>
                                    {
                                        this.props.categoryData && this.props.categoryData.map((c, index)=>{

                                            const isSelected = this.state.categoriesSelected.find(i=>i===c._id)

                                            return(
                                                <Grid item container key={c._id} id={`category_${c._id}`} className="category_box_wrapper"
                                                    style={{marginRight:((index+1)%3===0)?'0%':'2%'}}
                                                >
                                                <Grid item container justifyContent='center' 
                                                    className={isSelected?'filters_category_box_selected':'filters_category_box'}
                                                    onClick={()=>this.handleSelectCategory(c._id)}
                                                >
                                                    <Grid item container xs={12} justifyContent='flex-end'>
                                                        <Checkbox
                                                            checked={isSelected?true:false}
                                                            onChange={(e) => this.handleSelectCategory(c._id) }
                                                            onClick={(e) => e.stopPropagation()}
                                                            icon={<CheckBoxOutlineBlank/>}
                                                            checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                            id={`category__checkbox_${c._id}`}
                                                        />
                                                    </Grid>
                                                    <Grid item container xs={12} justifyContent='center'>
                                                        <img
                                                            src={c.iconUrl}
                                                            alt='category_icon'
                                                            width='32px'
                                                            height='32px'
                                                        />
                                                    </Grid>
                                               
                                                    <Grid className="ligth_txt" style={{textAlign:'center'}}>{c.name}</Grid>
                                                </Grid>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>

                                {/* Registrations */}
                                <Grid item container xs={12} className='sectionMargin'>
                                    <Grid item xs={12} className='filters_subtitles'>Registrations</Grid>

                                    {/* Range between registrations */}
                                    <Grid item container xs={12} className="sectionMargin" alignItems='center'>
                                        <Grid item xs={2}>
                                            <Field
                                                idToSet='registrations_switch'
                                                name="registrations"
                                                checked={this.state.registrationsActive}
                                                onClick={()=>this.setState(prevState=>({ registrationsActive: !prevState.registrationsActive }))}
                                                component={renderSwitchV3}
                                            />
                                        </Grid>
                                    
                                        <Grid item container xs={10} className="ligth_txt" alignItems='center'>

                                        <Autocomplete
                                            id='registrations_dropdown'
                                            style={{width:'65%'}}
                                            options={registrationsOptions}
                                            value={this.state.registrationsOption}
                                            name="Registrations"
                                            getOptionSelected={(option, value) => option === value ? true : false}
                                            getOptionLabel={option => option}
                                            disableClearable
                                            renderOption={option => {
                                                return (
                                                    <Grid item container xs={12}>
                                                        <Grid item xs={1}>
                                                            {
                                                                this.state.registrationsOption === option &&
                                                                <FontAwesomeIcon
                                                                    icon={faCheck}
                                                                    color='white'
                                                                    size='1x'
                                                                />
                                                            }
                                                        </Grid>
                                                    
                                                        <span style={{ marginLeft: '10px', fontFamily: 'Gotham-Book', fontSize: '14px' }}>{option}</span>
                                                    </Grid>
                                                )
                                            }}
                                            classes={{
                                                listbox:"roomsAutocompleteListbox"
                                            }}
                                            renderInput={(params) => {
                                                return (<>
                                                    <TextField
                                                        {...params}
                                                        className='registrations_select'
                                                        style={{fontSize:'14px'}}
                                                        InputProps={{ ...params.InputProps, disableUnderline:true }}
                                                    />
                                                </>
                                                )
                                            }}
                                            clearOnEscape={true}
                                            onChange={(e, newItem)=>{
                                                this.setState({registrationsOption: newItem, registrationsActive:true})
                                            
                                            }}
                                        />

                                            {
                                                this.state.registrationsOption===registrationsOptions[0]?
                                                <TextField
                                                    name='greater_than'
                                                    value={this.state.lowerLimit}
                                                    onChange={(e)=>{
                                                        const input = this.CheckForValidCaracters(e.target.value);
                                                        this.setState({lowerLimit: input, registrationsActive: (input.length>0)? true: false})
                                                    }}
                                                    className='registrations_txt'
                                                    classes={{
                                                        input:"registrations_txt-root"
                                                    }}
                                                />
                                                :
                                                this.state.registrationsOption===registrationsOptions[1]?
                                                <TextField
                                                    name='less_than'
                                                    value={this.state.upperLimit}
                                                    onChange={(e)=>{
                                                        const input = this.CheckForValidCaracters(e.target.value);
                                                        this.setState({upperLimit: input, registrationsActive: (input.length>0)? true: false})
                                                    }}
                                                    className='registrations_txt'
                                                    classes={{
                                                        input:"registrations_txt-root"
                                                    }}

                                                />
                                                :
                                                this.state.registrationsOption===registrationsOptions[2]?
                                                <>
                                                    <TextField
                                                        name='lower_limit'
                                                        value={this.state.lowerLimit}
                                                        onChange={(e)=>{
                                                            const input = this.CheckForValidCaracters(e.target.value);
                                                            this.setState({lowerLimit: input, registrationsActive: (input.length>0)? true: false})
                                                        }}
                                                        className='registrations_txt'
                                                        classes={{
                                                            input:"registrations_txt-root"
                                                        }}
                                                    />
                                                    &
                                                    <TextField
                                                        name='under_limit'
                                                        value={this.state.upperLimit}
                                                        onChange={(e)=>{
                                                            const input = this.CheckForValidCaracters(e.target.value);
                                                            this.setState({upperLimit:input, registrationsActive:(input.length>0)? true: false})
                                                        }}
                                                        className='registrations_txt'
                                                        classes={{
                                                            input:"registrations_txt-root"
                                                        }}

                                                    />
                                                
                                                </>
                                                :
                                                undefined
                                            }

                                            <Grid item xs={12} className="ligth_txt">{(this.state.lowerLimit===1)?'Registration' :'Registrations'}</Grid>

                                        </Grid>
                                    </Grid>

                                    {/* Unlimited seats */}
                                    <Grid item container xs={12} className="sectionMargin">
                                        <Grid item xs={2}>
                                            <Field
                                                idToSet='unlimited_seats_switch'
                                                name="registrations"
                                                checked={this.state.unlimitedSeats}
                                                onClick={()=>this.setState(prevState=>({ unlimitedSeats: !prevState.unlimitedSeats }))}
                                                component={renderSwitchV3}
                                            />
                                        </Grid>
                                    
                                        <Grid item container xs={10} className="ligth_txt">
                                            Only show activities with unlimited seating
                                        </Grid>
                                    </Grid>

                               

                                  
                                    
                                </Grid>

                                {/* Tags */}
                                <Grid item container xs={12} className='sectionMargin' >
                                    <Grid item xs={12} className='filters_subtitles'>Tags</Grid>

                                    {
                                        this.props.tags && this.props.tags.map((t, index)=>{
                                            const isSelected=this.state.tagsSelected.find(i=>i===t);

                                            return(
                                                <Chip
                                                    className={isSelected?'tags_styles_selected':"tags_styles"}
                                                    key={'chip' + index}
                                                    size='large'
                                                    label={t}
                                                    onClick={()=>this.handleSelectTag(t)}
                                                />
                                            )
                                        })
                                    }

                                </Grid>

                                {/* Apply filters button */}
                                <Grid item container xs={12} className='sectionMargin'>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                </Grid>

                            </form>
                        </Grid>
                    </Slide>
                </Popover>
            </>
        )
    }
}


function mapStateToProps(state){
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];
    const tags = (state.activityReducer && state.activityReducer.tags) ? state.activityReducer.tags : [];

    return{
        categoryData,
        tags
    };
}


export default connect(mapStateToProps,{GetActivitiesTags})(reduxForm({
    form: 'ActivityFilters',
})(ActivityFilters));

